import { render, staticRenderFns } from "./phone-number-validation-details-dialog.vue?vue&type=template&id=5141281f&scoped=true&"
import script from "./phone-number-validation-details-dialog.vue?vue&type=script&lang=js&"
export * from "./phone-number-validation-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141281f",
  null
  
)

export default component.exports